export default "__VITE_ASSET__Ikizca3J__"